<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <Input v-model="query.epNo" placeholder="环保登记号码" clearable></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="equipment">
                {{row.equipment.plateNo}}
            </template>
            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>
        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="登录名" prop="userName" :rules="[rules.required]">
                    <Input v-model="modalForm.userName" placeholder="登录名"></Input>
                </FormItem>
                <FormItem label="密码" prop="password" :rules="[rules.required]">
                    <Input type="password" v-model="modalForm.password" placeholder="密码"></Input>
                </FormItem>
                <FormItem label="确认密码" prop="confirmPassword" :rules="[rules.required]">
                    <Input type="password" v-model="modalForm.confirmPassword" placeholder="确认密码"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>

    </Card>
</template>
<script>
    import iEquip from '@/module/main/api/iEquip'
    import tableHelper from '@/mixins/tableHelper';
    import rules from '@/libs/rules';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        userName: null,
        departmentId:null,
        department: {id:null},
        password:null,
        confirmPassword:null,
    };

    export default {
        name: "violation_mng",
        mixins: [tableHelper],
        components: {
        },
        data() {
            return {
                rules,
                query:{
                    epNo:null,
                    status:null,
                },

                tableColumns: [
                    {title: '车牌号', slot: 'equipment', width: 100},
                    {title: '违法行为', key: 'info', width: 200},
                    {title: '违法地点', key: 'address'},
                    {title: '添加时间', key: 'addTime', width: 180},
                    {title: '操作', slot: 'operation', width: 160}
                ],

                modalTitle:'违法处理',
                modalVisible:false,
                modalLoading:false,
                modalForm:_don.cloneWithModal(modalFormTemplate)
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                if (this.query.status == '') {
                    this.query.userName = null
                }
                if (this.query.epNo == '') {
                    this.query.epNo = null
                }
                iEquip.violationList(this.page, this.query).then(res => {
                    this.tableList = res.content
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.$refs.baseForm.resetFields();
                    this.modalVisible = true
                    this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `是否确定删除该违法记录？`,
                        onOk: () => {
                            iEquip.violationDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    if (this.modalForm.password != this.modalForm.confirmPassword) {
                        this.$Message.error('两次输入的密码不一致')
                        return
                    }
                    this.modalForm.department.id = this.modalForm.departmentId
                    iUser.userAdd(this.modalForm).then(() => {
                        this.$Message.success('操作成功');
                        this.getTableData()
                        this.modalVisible = false
                    });
                });
            }
        },
    }
</script>

<style scoped lang="less">

</style>
